<template>
<div class="form">
<a-card :title="c_title">
    <v-gobackbutton v-show="isGuide != 'process'" slot="extra" >返回</v-gobackbutton>
        <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-form-model-item ref="templatecode" label="短信模板编码" prop="templatecode">
                <a-input
                    v-model="record.templatecode"
                     @blur="
                        () => {
                            $refs.templatecode.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="templatename" label="短信模板名称" prop="templatename">
                <a-input
                    v-model="record.templatename"
                     @blur="
                        () => {
                            $refs.templatename.onFieldBlur();
                        }
                        "
                />
            </a-form-model-item>
            <a-form-model-item ref="templatetext" label="短信模板内容" prop="templatetext">
                <a-textarea
                             v-model="record.templatetext"
                     @blur="
                        () => {
                            $refs.templatetext.onFieldBlur();
                        }
                        "
                 />
            </a-form-model-item>

            <a-form-model-item label="是否是oem类短信" prop="needoem" >
                <a-select v-model="record.needoem" placeholder="请选择是否是oem类短信" style="width:142px" >
                    <a-select-option value="0">
                    否
                    </a-select-option>
                    <a-select-option value="1">
                    是
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item label="短信模板类型" prop="templatetype" >
                <a-select v-model="record.templatetype" placeholder="请选择短信模板类型" style="width:142px" >
                    <a-select-option value="1">
                    验证码
                    </a-select-option>
                    <a-select-option value="2">
                    通知短信
                    </a-select-option>
                     <a-select-option value="3">
                    推广短信
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            <a-form-model-item ref="signname" label="短信模板签名" prop="signname">
                            <a-input
                                v-model="record.signname"
                                 @blur="
                                    () => {
                                        $refs.signname.onFieldBlur();
                                    }
                                    "
                            />
            </a-form-model-item>

            <a-form-model-item v-show="is_vue_task"  style="text-align: center">
                <a-button type="primary" @click="handleOk">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" @click="handleCancel">
                    取消
                </a-button>
            </a-form-model-item>
        </a-form-model>

 </a-card>
</div>
  
</template>
<script>
import { mapState } from "vuex";
const m_title = {
    'add':'新增短信模版',
    'edit':'编辑短信模版',
};
export default {
    data() {
        return {
            c_title:'',
            is_vue_task : true,
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            type:'',
            rules: {
                templatecode: [
                    { required: true, message: '请输入 短信模板编码', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                templatename: [
                    { required: true, message: ' 请输入 短信模板名称 ', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                templatetext: [
                    { required: true, message: '请输入 短信模板内容', trigger: 'blur' },
                    { min: 1, max: 200, message: '请输入1~200个字符', trigger: 'blur' },
                ],
                needoem: [
                    { required: true, message: ' 请选择 是否是oem类短信', trigger: 'change' },
                ],
                templatetype: [
                    { required: true, message: ' 请选择短信模板类型', trigger: 'change' },
                ],
            },
            confirmLoading: false,
            formItemLayout:'horizontal'
        };
    },
    props:{
        isGuide:String
    },
    computed: {
        ...mapState("smsmanager", {
            record: function(state) {
                console.log("state===>"+state);
                return this.action == "addTemplate" ? {} : state.record;
            }
        })
    },

    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.confirmLoading = true;
                    const { params } = this.$route;
                    if(params.action == 'editTemplate' || params.action == 'detailTemplate'){
                        //编辑
                        this.record.id = this.record.id;
                        this.$store
                            .dispatch({
                                type: "smsmanager/editTemplate",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    console.log(response)
                                    this.handleCancel();
                                    this.confirmLoading = false;
                                }
                            });
                    }
                    else if(params.action == 'addTemplate'){
                        //新增
                        this.$store
                            .dispatch({
                                type: "smsmanager/addTemplate",
                                params: this.record
                            })
                            .then((response) => {
                                if(response.data.success == '1'){
                                    console.log(response)
                                    this.handleCancel();
                                }
                            });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
            
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },

    mounted(){
        const { query, params } = this.$route;
        this.c_title = m_title[params.action];
        this.type = params.action == "add";
        if (params.action != "add") {
            this.$store.dispatch({
                type: "smsmanager/detailTemplate",
                params: query,
                showMsg: false
            })
        }
        else{
            this.$store.dispatch({
                type: "smsmanager/getEmptyTemplate",
                params: query,
                showMsg: false
            })  
        }
        this.is_vue_task = params.action != 'orgdetail'
        
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
